import Component from '../core/Component';
import { disableScrolling, enableScrolling } from '../services/Viewport';
import { queryAll } from '../utils/dom';

const template = `
        <div class="VideoModal-bg" data-ref="close"></div>
        <div class="VideoModal-inner">
          <button class="VideoModal-close" data-ref="close"><span>&times;</span></button>
            <video preload="auto" autoplay controls data-ref="video">
                <source src="/files/videos/{src}.mp4" />
            </video>
        </div>
`;

export default class VideoModal extends Component {
  constructor(element) {
    super(element, {
      name: '',
      clickable: true,
    });
  }

  prepare() {
    const isAboutPage = document.body.classList.contains('page-about');
    const showPoster = this.options.poster ? this.options.poster : ''
    if (window.innerWidth >= 1200) {
      this.element.innerHTML +=
        `<video preload="auto" autoplay playsinline loop muted src="/files/videos/{src}.mp4" poster="${showPoster}"><source src="/files/videos/{src}.mp4" type="video/mp4"/></video>`.replace(
          /{src}/g,
          this.options.name + '_preview'
        );
    }

    if (isAboutPage && window.innerWidth <= 560) {
      this.element.innerHTML +=
        `<video preload="auto" autoplay playsinline loop muted src="/files/videos/{src}.mp4" poster="${showPoster}"><source src="/files/videos/{src}.mp4" type="video/mp4"/></video>`.replace(
          /{src}/g,
          this.options.name
        );
    }

    if (this.options.clickable) {
      const videos = this.element.querySelectorAll('video')

      Array.from(videos).forEach(videoItem => {
        if (videoItem.classList.contains('preloaded')) {
          videoItem.setAttribute('autoplay', true)
        } else {
          videoItem.removeAttribute('autoplay')
        }

      })
      this.element.addEventListener('click', (event) => {
        this.openModal(this.options.name);
      });
    }
  }

  openModal = (src) => {
    if (!this.modal) {
      this.modal = document.createElement('div');
      this.modal.classList.add('VideoModal');
      this.modal.classList.add('is-hidden');
      document.body.appendChild(this.modal);
      this.modal.innerHTML = template.replace(/{src}/g, src);

      setTimeout(() => {
        this.modal.classList.remove('is-hidden');
      }, 10);

      const triggersClose = queryAll('[data-ref="close"]', this.modal);

      triggersClose.forEach((element) => {
        element.addEventListener('click', (event) => {
          this.closeModal();
        });
      });

      this.video = this.modal.querySelector('[data-ref="video"]');
      this.video.addEventListener('ended', :: this.closeModal);

      document.addEventListener('keyup', this.handleKeyPress);

      // disableScrolling();
    } else {
      console.info('Modal already exists');
    }
  };

  closeModal = () => {
    if (this.modal) {
      enableScrolling();
      this.video.pause();
      document.removeEventListener('keyup', this.handleKeyPress);
      this.modal.classList.add('is-closing');
      setTimeout(() => {
        document.body.removeChild(this.modal);
        this.modal = null;
      }, 400);
    } else {
      console.info(`Modal doesn't exists`);
    }
  };

  handleKeyPress = (event) => {
    event.preventDefault();
    if (event.code === 'Escape') {
      this.closeModal();
    } else if (event.code === 'Space') {
      this.togglePause();
    } else if (event.code === 'ArrowLeft') {
      this.movePlayback(-5);
    } else if (event.code === 'ArrowRight') {
      this.movePlayback(5);
    }
  };

  togglePause = (event) => {
    if (this.video.paused) {
      this.video.play();
    } else {
      this.video.pause();
    }
  };

  movePlayback = (time) => {
    this.video.currentTime = this.video.currentTime + time;
  };
}
